namespace $.$$ {
	$mol_style_define($bog_bzrl_app_benefit, {
		flex: {
			direction: 'column',
		},
		align: {
			items: 'center',
		},
		textAlign: 'center',
		padding: '2rem',
		background: {
			color: $mol_theme.card,
		},
		border: {
			radius: $mol_gap.round,
		},
		gap: $mol_gap.block,

		Icon: {
			width: '4rem',
			height: '4rem',
			background: {
				color: '#FFF8E1',
			},
			border: {
				radius: '50%',
			},
			display: 'flex',
			justify: {
				content: 'center',
			},
			align: {
				items: 'center',
			},
			color: '#FFA000',
		},

		Title: {
			font: {
				size: '1rem',
				weight: 600,
			},
		},

		Description: {
			color: $mol_theme.shade,
			font: {
				size: '.875rem',
			},
		},
	})
}
